import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { SkillDetailsFragmentDoc } from '../../fragment/generated/SkillDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AllSkillsListQueryVariables = Types.Exact<{
  filters: Types.SkillsFilters;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AllSkillsListQuery = { skills: { success: boolean, totalCount: number, errorCode?: Types.PaginationErrorCodeEnum | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null } }> | null } };


export const AllSkillsListDocument = /*#__PURE__*/ gql`
    query allSkillsList($filters: SkillsFilters!, $sort: [SortType!], $first: Float, $after: String) {
  skills(filters: $filters, sort: $sort, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    success
    totalCount
    errorCode
    edges {
      node {
        ...SkillDetails
      }
    }
  }
}
    ${SkillDetailsFragmentDoc}`;

export function useAllSkillsListQuery(options: Omit<Urql.UseQueryArgs<AllSkillsListQueryVariables>, 'query'>) {
  return Urql.useQuery<AllSkillsListQuery, AllSkillsListQueryVariables>({ query: AllSkillsListDocument, ...options });
};